import { t } from '@lingui/macro';
import React from 'react';

import { DynamicParams } from '../../../../../../app/state/app.types';
import { useSelectorCombinedAssignModuleId } from '../../../../../../configuration';
import portalCommunication from '../../../../../services/mathletics-portal-communication-service';
import { TryNewCourseModal } from '../try-new-course-modal';
import Background from './assets/background.png';
import { useLocalStorage } from '@hooks';

export const RefreshedAssignAndReviewModal = () => {
    const { getItem } = useLocalStorage();
    const courseAssign = getItem('course-assign');
    const LAST_SELECTED_CLASS_ID = courseAssign?.LAST_SELECTED_CLASS?.value;
    const LAST_SELECTED_GROUP_KEY = `LAST_SELECTED_GROUP_ClASS_${LAST_SELECTED_CLASS_ID}`;
    const LAST_SELECTED_GROUP_ID = courseAssign?.[LAST_SELECTED_GROUP_KEY]?.value;
    const COMBINED_ASSIGN_MODULE_ID = useSelectorCombinedAssignModuleId();
    const handleClick = () => {
        portalCommunication.postPortalMessage({
            type: portalCommunication.MESSAGES.SET_DYNAMIC_PARAMS,
            message: { [DynamicParams.combinedAssignAndReviewDefaultTab]: 'activities' }
        });
    };

    return (
        <TryNewCourseModal
            heading={t`refreshedAssignReviewModal.heading`}
            subHeading={t`refreshedAssignReviewModal.subHeading`}
            background={Background}
            redirectToModuleId={COMBINED_ASSIGN_MODULE_ID}
            classId={LAST_SELECTED_CLASS_ID}
            groupId={LAST_SELECTED_GROUP_ID}
            clickHandler={handleClick}
        />
    );
};
